<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>

         <div class="border p-2 mb-2" v-if="message.job">
              <div class="row">
                <div class="col-auto">
                  <span class="bg-primary text-white px-3 font-size-26">
                    {{ message.job.job_number }}</span
                  >
                </div>
                <div class="col">
                  <p class="text-muted mt-2 mb-0" v-if="message.job.manufacture">
                    {{ message.job.manufacture.description }} -
                    {{ message.job.device_type.description }}
                     <br />
                    <span v-if="message.job.device_model">                     
                      <strong>{{ message.job.device_model.code }}</strong> -                     
                    </span>
                     {{ (message.job.imei_in? message.job.imei_in : message.job.serial_in) }}
                  </p>
                </div>
              </div>
            </div>
            
        <h4 class="font-weight-500">{{ message.subject }}</h4>
        <hr>
       

        <div
          class="p-2 mb-3 border-bottom"
          v-for="m in message.message_items"
          :key="m.id"
        >
         
            <p class="nl2br">{{ m.message }}</p>
             <v-lazy-image
              v-if="m.image"
              :src="m.image"
              class="img-fluid maxHeight500 mb-2"
            />
          
          <div class="row">
            <div class="col-auto">
              <b-avatar v-if="!m.user.image"></b-avatar>
              <b-avatar v-if="m.user.image" :src="m.user.image"></b-avatar>
            </div>
            <div class="col">
            <h6 class="mb-0 mt-1 font-weight-bold">
              {{ m.user.name }}
            </h6>
            <small class="text-muted">
              <i class="lni lni-calendar"></i>
              {{
                moment(new Date(m.created_at)).format("DD MMM YYYY, HH:mm:ss")
              }}

              |

              {{
                moment
                  .duration(
                    moment(Date.now()).diff(
                      moment(new Date(m.created_at)),
                      "seconds"
                    ),
                    "seconds"
                  )
                  .format("Y [year] D [day], H [hour &] m [min]")
              }}
              ago
            </small>
            </div>
          </div>
       

        </div>

         <form-base
          :submit-status="submitStatus"
          action="Reply"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            

            <form-group label="Message" :required="true">
              <textarea-autosize 
               
                @blur="$v.message.message.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.message.message.$error }"
                v-model="message.message"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.message.message.required"
              >
                Please enter mesage
              </div>
            </form-group>

         

            <form-group label="Image">
              <image-upload
                @files-uploaded="
                  message.image_id = $event;
                  imageUploading = false;
                "
                @files-uploaded-started="imageUploading = true"
                :multiple="false"
                :imageCrop="false"
                :validationState="imageVstate"
                acceptedTypes="image/*"
              />
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import partnerMessagingRepo from "@/api/repos/partnerMessagingRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import imageUpload from "@/components/common/ImageUpload";

export default {
  props: ["id"],

  
  computed: {
    imageVstate: function () {
      return null;
    },
  },

  components: {
    formBase,
    formGroup,
    imageUpload,
  },
  mounted() {
    this.getMessage();
  },

  data() {
    return {
      loading: false,
      message: {},
       errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  validations: {
    message: {      
      message: {
        required,
      },
    },
  },

  methods: {
    async getMessage() {
      try {
        this.loading = true;
        let { data } = await partnerMessagingRepo.get(this.id);
        this.message = data.message;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.message.message_id = this.id
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await partnerMessagingRepo.create(this.message);
          this.$emit("messageCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>
